var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86074 17.9495C13.4715 17.5451 16.3653 14.6586 16.7771 11.0478C17.3176 6.32661 13.648 2.30769 9.04813 2.25621V0.138273C9.04813 0.0206101 8.90105 -0.0418984 8.80177 0.031641L4.44088 3.23428C4.36734 3.28944 4.36734 3.39607 4.44088 3.45122L8.80177 6.65386C8.90105 6.7274 9.04813 6.66122 9.04813 6.54723V4.43297C12.2802 4.48445 14.8688 7.23483 14.6482 10.522C14.4606 13.3496 12.1552 15.6441 9.32758 15.8242C6.33084 16.0154 3.7827 13.8754 3.32676 11.0442C3.24219 10.5184 2.78256 10.136 2.25308 10.136C1.5949 10.136 1.08012 10.7206 1.18308 11.3714C1.82287 15.4051 5.54765 18.4312 9.86074 17.9495Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.f3caff91.svg";
export { ForwardRef as ReactComponent };